import { motion } from "framer-motion";
import React, { useContext, useEffect } from "react";
import { Context } from "../Store";
import styles from "./PrivacyPolicy.module.scss";
import parse from "html-react-parser";

const PrivacyPolicy = () => {
  let {
    dir,
    translate,
    setIsClicked,
    setIsHovering,
    backgroundBubble0L,
    backgroundBubble0R,
    variants1,
    siteInfoRes,
  } = useContext(Context);
  let { documentTitle, title } = translate?.privacyPolicy;
  let { privacy } = siteInfoRes;
  useEffect(() => {
    setIsClicked(false);
    setIsHovering(false);
  }, [setIsClicked, setIsHovering]);
  useEffect(() => {
    document.title = dir === "ltr" ? documentTitle[0] : documentTitle[1];
  }, [dir]);
  return (
    <>
      <motion.div
        variants={variants1}
        initial="hidden"
        animate="showComponets"
        exit="exit"
        id={styles.privacyPolicy}
      >
        {dir === "ltr" ? (
          <img
            src={backgroundBubble0L}
            className={styles.backgroundBubbleL}
            alt=""
          />
        ) : (
          <img
            src={backgroundBubble0R}
            className={styles.backgroundBubbleR}
            alt=""
          />
        )}

        <div className={styles.container}>
          <h2>{dir === "ltr" ? title[0] : title[1]}</h2>

          {parse(`<p>${privacy}</p>`)}
        </div>
      </motion.div>
    </>
  );
};

export default PrivacyPolicy;
